<p-table
  [value]="rows()"
  class="p-datatable-striped"
  showGridlines
  [scrollable]="true"
  scrollHeight="calc(90vh - 210px)"
>
  <ng-template #header>
    <tr>
      <th class="w-20 text-center" scope="col">{{ 'common.id' | transloco }}</th>
      <th class="text-left w-1/3" scope="col">
        {{ 'project.steps.providerResults.subcriteriaAttributes.attribute' | transloco }}
      </th>
      @if (!hideImportanceColumn()) {
        <th class="text-center w-48" scope="col">
          {{ 'common.importance' | transloco }}
        </th>
      }
      @for (provider of providers(); track provider.hrToolDirectusId) {
        <th class="text-center" scope="col">
          {{ provider.translatedName }}
        </th>
      }
    </tr>
  </ng-template>

  <ng-template #body let-row>
    <tr>
      <td class="text-center font-medium whitespace-nowrap">
        {{ row.rowCode ? row.rowCode : 'SC ' + row.scaNumber }}
      </td>
      <td class="text-left">
        <span>{{ row.label }}</span>
      </td>
      @if (!hideImportanceColumn()) {
        <td class="text-center">
          @if (row.importanceLabelTranslationKey) {
            <div class="flex items-center justify-between px-2">
              <span class="text-sm font-medium text-left truncate">{{
                row.importanceLabelTranslationKey | transloco
              }}</span>
              @if (row.importanceScore) {
                <app-importance-icon
                  class="ml-4 shrink-0"
                  [importanceScore]="row.importanceScore"
                ></app-importance-icon>
              }
            </div>
          } @else if (row.customerAverageRating !== null) {
            {{ row.customerAverageRating | appNumber: '1.2-2' }}
          } @else {
            <span class="text-gray-400">-</span>
          }
        </td>
      }
      @for (provider of providers(); track provider.hrToolDirectusId) {
        <td class="text-center">
          @let providerValue = row.providerValuesByHrToolId.get(provider.hrToolDirectusId);
          @if (providerValue !== null && providerValue !== undefined) {
            <span class="block text-center">{{ providerValue | appNumber: '1.1-1' }}</span>
          } @else {
            <span class="text-gray-400">-</span>
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td
        [attr.colspan]="providers().length + (hideImportanceColumn() ? 2 : 3)"
        class="text-center py-6"
      >
        {{ 'project.steps.providerResults.subcriteriaAttributes.noData' | transloco }}
      </td>
    </tr>
  </ng-template>
</p-table>
